export const CONNECT_TYPES = {
  INPUT: 1,
  RADIO: 2,
  INPUT_NUMBER: 3,
  SWITCH: 4,
  DATE_PICKER: 5,
  CHECKBOX: 6,
};

export class ResponsiveMessages {
  constructor(loadingMessage, successMessage, errorMessage) {
    this.loadingMessage = loadingMessage;
    this.successMessage = successMessage;
    this.errorMessage = errorMessage;
  }

  onLoading() {
    return getMessage(this.loadingMessage);
  }

  onSuccess() {
    return getMessage(this.successMessage);
  }

  onError(e) {
    return typeof this.errorMessage === 'function'
      ? this.errorMessage(e)
      : `${this.errorMessage} (${e})`;
  }
}

function getMessage(message) {
  return typeof message === 'function' ? message() : message;
}



// WEBPACK FOOTER //
// ./src/components/BaseForm/entities.js